import conversations from './sidebarItems/conversations';
import contacts from './sidebarItems/contacts';
import reports from './sidebarItems/reports';
import campaigns from './sidebarItems/campaigns';
import settings from './sidebarItems/settings';
import notifications from './sidebarItems/notifications';
import primaryMenu from './sidebarItems/primaryMenu';
import crm from './sidebarItems/crm';
import campaigns_flow from './sidebarItems/campaignsFlow';
import smart_survey from './sidebarItems/smartSurvey';
import typebot from './sidebarItems/typebot';
import dashboard_embed from './sidebarItems/dashboardEmbed';

export const getSidebarItems = (accountId, featureFlag) => ({
  primaryMenu: primaryMenu(accountId, featureFlag),
  secondaryMenu: [
    conversations(accountId),
    contacts(accountId),
    reports(accountId),
    campaigns(accountId),
    settings(accountId),
    notifications(accountId),
    crm(accountId),
    campaigns_flow(accountId),
    smart_survey(accountId),
    typebot(accountId),
    dashboard_embed(accountId),
  ],
});
